import { render, staticRenderFns } from "./kycView.vue?vue&type=template&id=257d2bec&scoped=true"
import script from "./kycView.vue?vue&type=script&lang=js"
export * from "./kycView.vue?vue&type=script&lang=js"
import style0 from "./kycView.vue?vue&type=style&index=0&id=257d2bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d2bec",
  null
  
)

export default component.exports